import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ShieldAlert, Home, ArrowLeft } from 'lucide-react';

export default function Forbidden() {
  return (
    <div className="flex flex-col min-h-[70vh] items-center justify-center text-center px-4 py-16 bg-white">
      <Helmet>
        <title>Adgang nægtet - 403 - KBS Tømrer – Montage ApS</title>
        <html lang="da" />
      </Helmet>

      <div className="rounded-full bg-amber-50 p-6 text-amber-500 mb-6 animate-pulse">
        <ShieldAlert className="h-16 w-16" />
      </div>

      <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-brand-charcoal tracking-tight mb-4">
        403 - Adgang nægtet
      </h1>

      <p className="text-slate-600 max-w-md leading-relaxed mb-8">
        Beklager, men du har ikke tilladelse til at tilgå denne side eller ressource.
      </p>

      <div className="flex flex-wrap justify-center gap-4">
        <Link
          to="/"
          className="flex items-center gap-2 px-6 py-3.5 text-sm font-bold text-white bg-brand-primary hover:bg-brand-primary-dark rounded-xl shadow transition-colors cursor-pointer"
        >
          <Home className="h-4 w-4" /> Gå til forsiden
        </Link>
        <button
          onClick={() => window.history.back()}
          className="flex items-center gap-2 px-6 py-3.5 text-sm font-bold text-brand-charcoal bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-xl transition-colors cursor-pointer"
        >
          <ArrowLeft className="h-4 w-4" /> Gå tilbage
        </button>
      </div>
    </div>
  );
}
